import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Keyboard } from "lucide-react";

const GROUPS = [
  {
    title: "Selection",
    rows: [
      ["Click", "Select widget (selects whole group if grouped)"],
      ["Ctrl + Click", "Add / remove from selection"],
      ["Ctrl + A", "Select all widgets"],
      ["Esc", "Clear selection"],
    ],
  },
  {
    title: "Editing",
    rows: [
      ["Ctrl + C", "Copy selected widgets (works across dashboards)"],
      ["Ctrl + V", "Paste widgets"],
      ["Ctrl + D", "Duplicate selection"],
      ["Delete / Backspace", "Delete selection"],
      ["Ctrl + G", "Group selection"],
      ["Ctrl + Shift + G", "Ungroup"],
    ],
  },
  {
    title: "History",
    rows: [
      ["Ctrl + Z", "Undo"],
      ["Ctrl + Shift + Z / Ctrl + Y", "Redo"],
    ],
  },
  {
    title: "Other",
    rows: [["?", "Show this cheat sheet"]],
  },
];

export function ShortcutSheet({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="shortcut-sheet">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><Keyboard className="w-5 h-5 text-[color:var(--brand-ocean)]" />Keyboard shortcuts</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <div className="text-[11px] uppercase tracking-wide text-[color:var(--ink-3)] mb-1.5">{g.title}</div>
              <div className="space-y-1">
                {g.rows.map(([k, d]) => (
                  <div key={k} className="flex items-center justify-between text-sm">
                    <kbd className="px-1.5 py-0.5 rounded-md bg-[color:var(--surface-2)] border border-[color:var(--glass-border)] text-[11px] font-mono text-[color:var(--ink-2)]">{k}</kbd>
                    <span className="text-xs text-[color:var(--ink-2)]">{d}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
